const DEFAULT_THEME_COLOR = 'green';

const THEME_PALETTES = {
  green: {
    id: 'green',
    label: 'Forest Green',
    swatch: '#2f7a4a',
    primary: '#2f7a4a',
    primaryMid: '#245c3a',
    primaryDark: '#1b4332',
    primaryLight: '#4caf73',
    primarySoft: '#e8f5ec',
    primaryBorder: '#b8dcc4',
    primaryMuted: '#d5ecdd',
    primaryText: '#1f5133',
    primaryFocus: '#4caf70',
    primaryBadgeStart: '#3d9b5f',
    primaryBadgeEnd: '#1f5133',
    bodyBg: '#eef6ef',
    surfaceSoft: '#f7fcf9',
    surfaceMuted: '#eef6ef',
    glow1: '62, 140, 90',
    glow2: '46, 110, 72',
    shadow: '20, 50, 30',
    accentShadow: '47, 122, 74',
    successBg: '#ecfdf3',
    successBorder: '#bbf7d0',
    successText: '#15803d',
    calendarLight: [232, 245, 236],
    calendarDark: [31, 81, 51],
    calendarBorderLight: [168, 212, 180],
    calendarBorderDark: [22, 61, 38],
  },
  red: {
    id: 'red',
    label: 'Cherry Red',
    swatch: '#c62828',
    primary: '#c62828',
    primaryMid: '#9e1f1f',
    primaryDark: '#7f1d1d',
    primaryLight: '#ef5350',
    primarySoft: '#fdecea',
    primaryBorder: '#f5b7b1',
    primaryMuted: '#fadbd8',
    primaryText: '#7b1818',
    primaryFocus: '#e57373',
    primaryBadgeStart: '#e53935',
    primaryBadgeEnd: '#7f1d1d',
    bodyBg: '#fdf3f3',
    surfaceSoft: '#fff8f8',
    surfaceMuted: '#fdecea',
    glow1: '198, 40, 40',
    glow2: '158, 31, 31',
    shadow: '60, 20, 20',
    accentShadow: '198, 40, 40',
    successBg: '#ecfdf3',
    successBorder: '#bbf7d0',
    successText: '#15803d',
    calendarLight: [253, 236, 234],
    calendarDark: [123, 24, 24],
    calendarBorderLight: [245, 183, 177],
    calendarBorderDark: [127, 29, 29],
  },
  blue: {
    id: 'blue',
    label: 'Ocean Blue',
    swatch: '#1565c0',
    primary: '#1565c0',
    primaryMid: '#0d47a1',
    primaryDark: '#0a3d7a',
    primaryLight: '#42a5f5',
    primarySoft: '#e8f1fb',
    primaryBorder: '#b3d4f5',
    primaryMuted: '#d0e3f9',
    primaryText: '#0a3d7a',
    primaryFocus: '#64b5f6',
    primaryBadgeStart: '#1e88e5',
    primaryBadgeEnd: '#0a3d7a',
    bodyBg: '#f0f6fd',
    surfaceSoft: '#f7fbff',
    surfaceMuted: '#e8f1fb',
    glow1: '21, 101, 192',
    glow2: '13, 71, 161',
    shadow: '15, 35, 60',
    accentShadow: '21, 101, 192',
    successBg: '#ecfdf3',
    successBorder: '#bbf7d0',
    successText: '#15803d',
    calendarLight: [232, 241, 251],
    calendarDark: [10, 61, 122],
    calendarBorderLight: [179, 212, 245],
    calendarBorderDark: [10, 61, 122],
  },
  purple: {
    id: 'purple',
    label: 'Grape Purple',
    swatch: '#7b1fa2',
    primary: '#7b1fa2',
    primaryMid: '#6a1b9a',
    primaryDark: '#4a148c',
    primaryLight: '#ab47bc',
    primarySoft: '#f3e8f8',
    primaryBorder: '#d7bde8',
    primaryMuted: '#e8d4f0',
    primaryText: '#4a148c',
    primaryFocus: '#ba68c8',
    primaryBadgeStart: '#8e24aa',
    primaryBadgeEnd: '#4a148c',
    bodyBg: '#f7f0fa',
    surfaceSoft: '#fbf7fd',
    surfaceMuted: '#f3e8f8',
    glow1: '123, 31, 162',
    glow2: '106, 27, 154',
    shadow: '45, 20, 60',
    accentShadow: '123, 31, 162',
    successBg: '#ecfdf3',
    successBorder: '#bbf7d0',
    successText: '#15803d',
    calendarLight: [243, 232, 248],
    calendarDark: [74, 20, 140],
    calendarBorderLight: [215, 189, 232],
    calendarBorderDark: [74, 20, 140],
  },
  orange: {
    id: 'orange',
    label: 'Sunset Orange',
    swatch: '#e65100',
    primary: '#e65100',
    primaryMid: '#c43e00',
    primaryDark: '#9a3100',
    primaryLight: '#ff9800',
    primarySoft: '#fff3e8',
    primaryBorder: '#ffcc99',
    primaryMuted: '#ffe0bf',
    primaryText: '#9a3100',
    primaryFocus: '#ffb74d',
    primaryBadgeStart: '#f57c00',
    primaryBadgeEnd: '#9a3100',
    bodyBg: '#fff8f0',
    surfaceSoft: '#fffcf8',
    surfaceMuted: '#fff3e8',
    glow1: '230, 81, 0',
    glow2: '196, 62, 0',
    shadow: '60, 35, 10',
    accentShadow: '230, 81, 0',
    successBg: '#ecfdf3',
    successBorder: '#bbf7d0',
    successText: '#15803d',
    calendarLight: [255, 243, 232],
    calendarDark: [154, 49, 0],
    calendarBorderLight: [255, 204, 153],
    calendarBorderDark: [154, 49, 0],
  },
  teal: {
    id: 'teal',
    label: 'Pacific Teal',
    swatch: '#00796b',
    primary: '#00796b',
    primaryMid: '#00695c',
    primaryDark: '#004d40',
    primaryLight: '#26a69a',
    primarySoft: '#e0f2f1',
    primaryBorder: '#a7d9d3',
    primaryMuted: '#c5e8e4',
    primaryText: '#004d40',
    primaryFocus: '#4db6ac',
    primaryBadgeStart: '#00897b',
    primaryBadgeEnd: '#004d40',
    bodyBg: '#edf8f7',
    surfaceSoft: '#f4fcfb',
    surfaceMuted: '#e0f2f1',
    glow1: '0, 121, 107',
    glow2: '0, 105, 92',
    shadow: '10, 45, 40',
    accentShadow: '0, 121, 107',
    successBg: '#ecfdf3',
    successBorder: '#bbf7d0',
    successText: '#15803d',
    calendarLight: [224, 242, 241],
    calendarDark: [0, 77, 64],
    calendarBorderLight: [167, 217, 211],
    calendarBorderDark: [0, 77, 64],
  },
  rose: {
    id: 'rose',
    label: 'Rose Pink',
    swatch: '#c2185b',
    primary: '#c2185b',
    primaryMid: '#a0144a',
    primaryDark: '#7a1038',
    primaryLight: '#ec407a',
    primarySoft: '#fce8f0',
    primaryBorder: '#f5b8cc',
    primaryMuted: '#f9d0de',
    primaryText: '#7a1038',
    primaryFocus: '#f06292',
    primaryBadgeStart: '#d81b60',
    primaryBadgeEnd: '#7a1038',
    bodyBg: '#fdf2f7',
    surfaceSoft: '#fff8fb',
    surfaceMuted: '#fce8f0',
    glow1: '194, 24, 91',
    glow2: '160, 20, 74',
    shadow: '60, 15, 35',
    accentShadow: '194, 24, 91',
    successBg: '#ecfdf3',
    successBorder: '#bbf7d0',
    successText: '#15803d',
    calendarLight: [252, 232, 240],
    calendarDark: [122, 16, 56],
    calendarBorderLight: [245, 184, 204],
    calendarBorderDark: [122, 16, 56],
  },
  amber: {
    id: 'amber',
    label: 'Golden Amber',
    swatch: '#f9a825',
    primary: '#f9a825',
    primaryMid: '#f57f17',
    primaryDark: '#c17900',
    primaryLight: '#ffca28',
    primarySoft: '#fff8e1',
    primaryBorder: '#ffe082',
    primaryMuted: '#ffecb3',
    primaryText: '#8a5a00',
    primaryFocus: '#ffd54f',
    primaryBadgeStart: '#ffb300',
    primaryBadgeEnd: '#c17900',
    bodyBg: '#fffbf0',
    surfaceSoft: '#fffdf7',
    surfaceMuted: '#fff8e1',
    glow1: '249, 168, 37',
    glow2: '245, 127, 23',
    shadow: '60, 45, 10',
    accentShadow: '249, 168, 37',
    successBg: '#ecfdf3',
    successBorder: '#bbf7d0',
    successText: '#15803d',
    calendarLight: [255, 248, 225],
    calendarDark: [193, 121, 0],
    calendarBorderLight: [255, 224, 130],
    calendarBorderDark: [193, 121, 0],
  },
};

export function getThemePalette(themeColor) {
  const key = THEME_PALETTES[themeColor] ? themeColor : DEFAULT_THEME_COLOR;
  return THEME_PALETTES[key];
}

export function getThemeColorOptions() {
  return Object.values(THEME_PALETTES).map(({ id, label, swatch }) => ({ id, label, swatch }));
}

export function applyTheme(themeColor) {
  const palette = getThemePalette(themeColor);
  const root = document.documentElement;

  root.style.setProperty('--mwb-primary', palette.primary);
  root.style.setProperty('--mwb-primary-mid', palette.primaryMid);
  root.style.setProperty('--mwb-primary-dark', palette.primaryDark);
  root.style.setProperty('--mwb-primary-light', palette.primaryLight);
  root.style.setProperty('--mwb-primary-soft', palette.primarySoft);
  root.style.setProperty('--mwb-primary-border', palette.primaryBorder);
  root.style.setProperty('--mwb-primary-muted', palette.primaryMuted);
  root.style.setProperty('--mwb-primary-text', palette.primaryText);
  root.style.setProperty('--mwb-primary-focus', palette.primaryFocus);
  root.style.setProperty('--mwb-primary-badge-start', palette.primaryBadgeStart);
  root.style.setProperty('--mwb-primary-badge-end', palette.primaryBadgeEnd);
  root.style.setProperty('--mwb-body-bg', palette.bodyBg);
  root.style.setProperty('--mwb-surface-soft', palette.surfaceSoft);
  root.style.setProperty('--mwb-surface-muted', palette.surfaceMuted);
  root.style.setProperty('--mwb-glow-1', palette.glow1);
  root.style.setProperty('--mwb-glow-2', palette.glow2);
  root.style.setProperty('--mwb-shadow', palette.shadow);
  root.style.setProperty('--mwb-accent-shadow', palette.accentShadow);
  root.style.setProperty('--mwb-success-bg', palette.successBg);
  root.style.setProperty('--mwb-success-border', palette.successBorder);
  root.style.setProperty('--mwb-success-text', palette.successText);
  root.style.setProperty('--mwb-cal-light', palette.calendarLight.join(', '));
  root.style.setProperty('--mwb-cal-dark', palette.calendarDark.join(', '));
  root.style.setProperty('--mwb-cal-border-light', palette.calendarBorderLight.join(', '));
  root.style.setProperty('--mwb-cal-border-dark', palette.calendarBorderDark.join(', '));

  document.body.style.background = palette.bodyBg;
  return palette;
}

export function getCalendarDayColors(count) {
  const level = Math.min(Math.max(Number(count) || 0, 0), 10);
  if (level < 1) return null;

  const palette = getThemePalette(
    document.documentElement.getAttribute('data-mwb-theme') || DEFAULT_THEME_COLOR
  );
  const t = (level - 1) / 9;
  const lerp = (from, to) => Math.round(from + (to - from) * t);
  const [lr, lg, lb] = palette.calendarLight;
  const [dr, dg, db] = palette.calendarDark;
  const [blr, blg, blb] = palette.calendarBorderLight;
  const [bdr, bdg, bdb] = palette.calendarBorderDark;

  return {
    background: `rgb(${lerp(lr, dr)}, ${lerp(lg, dg)}, ${lerp(lb, db)})`,
    borderColor: `rgb(${lerp(blr, bdr)}, ${lerp(blg, bdg)}, ${lerp(blb, bdb)})`,
    color: t >= 0.55 ? '#ffffff' : palette.primaryText,
  };
}

export function applyThemeWithAttribute(themeColor) {
  const palette = applyTheme(themeColor);
  document.documentElement.setAttribute('data-mwb-theme', palette.id);
  return palette;
}

export { DEFAULT_THEME_COLOR };
